export const Channels = [
    { text: 'BLiP Chat', value: '0mn.io' },
    { text: 'Messenger', value: 'messenger.gw.msging.net' },
    { text: 'Workplace', value: 'workplace.gw.msging.net' },
    { text: 'Telegram', value: 'telegram.gw.msging.net' },
    { text: 'E-mail', value: 'mailgun.gw.msging.net' },
    { text: 'Instagram', value: 'instagram.gw.msging.net' },
    { text: 'Google RCS', value: 'googlercs.gw.msging.net' },
    { text: 'PagSeguro', value: 'pagseguro.gw.msging.net' },
    { text: 'Whatsapp', value: 'wa.gw.msging.net' },
    { text: 'Google Assistent', value: 'assistant.gw.msging.net' },
    { text: 'Azure Bot Service', value: 'abs.gw.msging.net' },
    { text: 'Apple Messages for Business', value: 'businesschat.gw.msging.net' },
    { text: 'Amazon Alexa', value: 'alexa.gw.msging.net' },
];
